<template>
	<div id="app" class="am-app">
		<transition name="router" mode="out-in">
			<router-view></router-view>
			<router-view :key="$route.fullPath" name="post"></router-view>
		</transition>
		<div class="whatsapp" @click="onClick('whatsapp')">
			<div class="whatsapp--icon"></div>
		</div>
	</div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { mapGetters } from 'vuex'

export default {
	mounted() {
		// Initialize viewport module
		this.$store.commit('viewport/init')

		// Disable body scroll on smartphones
		disableBodyScroll(this.$el.querySelector('.ch-app__container'))
	},

	methods: {
		onClick(provider){
			if (provider == 'whatsapp'){
				window.open("https://wa.me/5583998400076","_blank")
			}
		}
	}
	
}
</script>

<style lang="scss">
body, html{
	height: 100%
}
@font-face {
	font-family: 'Flama-Light';
	font-style: normal;
	font-weight: normal;
	src: local('Flama-Light'), url('../public/fonts/Flama-Light.woff') format('woff');
}

.am-app{
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
	display: flex;
	flex-flow: column;
	position: relative;
}

.whatsapp{
	width: 70px;
	height: 70px;
	position: fixed;
	background-color: #6D594F;
	bottom: 15px;
	right: 15px;
	border-radius: 100px;
	z-index: 99999;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 1px 2px 5px 3px rgba(0,0,0,.1);
	cursor: pointer;
	&--icon{
		&:before{
			font-family: "americas"!important;
			content: "v";
			font-size: 24px;
			color: #fff;
		}
	}
}

</style>
